const restMethods = {
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};

export default restMethods;
